import { render, staticRenderFns } from "./SearchResultPlaceholders.vue?vue&type=template&id=9ed03c40&scoped=true&"
import script from "./SearchResultPlaceholders.vue?vue&type=script&lang=js&"
export * from "./SearchResultPlaceholders.vue?vue&type=script&lang=js&"
import style0 from "./SearchResultPlaceholders.vue?vue&type=style&index=0&id=9ed03c40&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ed03c40",
  null
  
)

export default component.exports